/* The original Multicolumn uses SliderElement for scrolling and button state. */
if (!customElements.get('multicolumn-navigation')) {
  customElements.define('multicolumn-navigation', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.slider = this.querySelector('slider-element');
        this.controls = this.querySelector('[data-multicolumn-controls]');
        if (!this.slider || !this.controls) return;
        this.desktop = matchMedia('(min-width: 1024px)');
        this.update = () => {
          this.controls.hidden = !this.desktop.matches || !this.slider.isScrollable || this.slider.scrollWidth <= this.slider.clientWidth + 1;
          const media = this.slider.querySelector('.card .media') || this.slider;
          const image = media.getBoundingClientRect();
          this.style.setProperty('--multicolumn-image-center', `${image.top - this.getBoundingClientRect().top + image.height / 2}px`);
          if (this.slider.initialized) this.slider.updateButtons();
        };
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.slider);
        const media = this.slider.querySelector('.card .media');
        if (media) this.observer.observe(media);
        this.slider.addEventListener('slider:ready', this.update);
        this.desktop.addEventListener('change', this.update);
        this.update();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.slider?.removeEventListener('slider:ready', this.update);
      this.desktop?.removeEventListener('change', this.update);
    }
  });
}
